import { render, staticRenderFns } from "./admin-dropped-2025.vue?vue&type=template&id=21550d6c&scoped=true"
import script from "./admin-dropped-2025.vue?vue&type=script&lang=js"
export * from "./admin-dropped-2025.vue?vue&type=script&lang=js"
import style0 from "./admin-dropped-2025.vue?vue&type=style&index=0&id=21550d6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21550d6c",
  null
  
)

export default component.exports